import { Pipe, PipeTransform } from '@angular/core';
import { DataObject } from '@shared/models/data-object.model';
export const DEFAULT_ALL_ID = 'All';
@Pipe({ name: 'customFuncFilter' })
export class CustomFuncFilterPipe implements PipeTransform {
  transform(records: DataObject[], filterType: string, customFunc: Function, path: string) {
    const list = records || [];
    if (customFunc == null || filterType === DEFAULT_ALL_ID) {
      return list;
    }
    // Per-row predicate (arity ≤ 1) vs batch (records, filterType, path).
    if (customFunc.length <= 1) {
      return list.filter((record: DataObject) => customFunc(record));
    }
    const result = customFunc(list, filterType, path);
    return Array.isArray(result) ? result : list;
  }
}
